module.exports = __webpack_public_path__ + "media/baseattack2.efb2c93a.mp4";